export default "__VITE_ASSET__Bmr4mQTP__"